import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { preprocessTextAsyncAutocompleteField } from "@/features/FormCard/utils";
import { z } from "zod";

// Define a type compatible with FilterTable
export const filterEnumTranslationsSchema = z.object({
  class_name_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional()
    .nullable(),
  column_name_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional()
    .nullable(),
  // enum_code: z
  //   .preprocess(
  //     (val) => (val && typeof val === "string" ? parseInt(val, 10) : val),
  //     z.number().optional()
  //   )
  //   .optional(),
  pg_code_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional()
    .nullable(),
  enum_key_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional()
    .nullable(),
});

export type FilterEnumTranslationsSchema = z.infer<
  typeof filterEnumTranslationsSchema
>;

export const fields: Field[] = [
  {
    name: "class_name_contains",
    label: "Class Name",
    type: "asyncAutocomplete",
    base_url: "etl-quantilia/enum_translations",
    column_name: "class_name",
  },
  {
    name: "column_name_contains",
    label: "Column Name",
    type: "asyncAutocomplete",
    base_url: "etl-quantilia/enum_translations",
    column_name: "column_name",
  },
  // {
  //   name: "enum_code",
  //   label: "Enum Code",
  //   type: "input",
  // },
  {
    name: "pg_code_contains",
    label: "PG Code",
    type: "asyncAutocomplete",
    base_url: "etl-quantilia/enum_translations",
    column_name: "pg_code",
  },
  {
    name: "enum_key_contains",
    label: "Enum Key",
    type: "asyncAutocomplete",
    base_url: "etl-quantilia/enum_translations",
    column_name: "enum_key",
  },
];

export const client = "qtl - referential";

export function FilterEnumTranslations() {
  return (
    <FilterTable
      client={client}
      schema={filterEnumTranslationsSchema}
      tableName="enum_translations"
      customBuildPath={() => `${client}/enum_translations`}
      fields={fields}
    />
  );
}
